/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import classes from "../checkout.module.css";
import Grid from "@mui/material/Grid";
import Textarea from "../../../../component/textarea";
import Input from "../../../../component/inputpm";
import { withTranslation, Trans } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

const NotesBlock = (props) => {
  const [shipmentMethodTypeList, setShipmentMethodTypeList] = useState([
    {
      name: "Federal Express - Standard Overnight",
      value: "ST_OVERNIGHT | FEDEX",
    },
    {
      name: "Federal Express - International Priority",
      value: "INTERNAT_PRI | FEDEX",
    },
    {
      name: "Federal Express - International Economy",
      value: "INTERNAT_ECON | FEDEX",
    },
    {
      name: "Federal Express - Europe First Priority",
      value: "EUROPE_FI_PRIORITY | FEDEX",
    },
    {
      name: "Federal Express - Fedex International Ground",
      value: "FEDEX_INT_GROUND | FEDEX",
    },
    {
      name: "Federal Express - Next Morning",
      value: "NEXT_AM | FEDEX",
    },
    {
      name: "Federal Express - Same Day",
      value: "SAME_DAY | FEDEX",
    },
    {
      name: "Federal Express - Guaranteed Next Day",
      value: "NEXT_DAY | FEDEX",
    },
    {
      name: "UPS - Standard",
      value: "UPS - STANDARD | UPS",
    },
    {
      name: "UPS - Worldwide ExpressSM",
      value: "WORLDWIDE_EXPRESS | UPS",
    },
    {
      name: "UPS - Worldwide ExpeditedSM",
      value: "WORLDWIDE_EXPEDITED | UPS",
    },
    {
      name: "DHL - International Express",
      value: "INT_EXPRESS | DHL",
    },
    {
      name: "DHL - Express",
      value: "EXPRESS | DHL",
    },
    {
      name: "DHL - Second Day",
      value: "SECOND_DAY | DHL",
    },
  ]);
  return (
    <Grid container spacing={3}>
      {(props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
        props.loggedInUserType != "ECOMMERCE_ADMIN") && (
        <>
          {/* <Grid item xs={12}><Label label={props.t('AGENT_ID')} edit={props.edit} stage={props.stage} t={props.t} /></Grid> */}
          <Grid
            item
            size={{
              xs: 6,
            }}
          >
            <div style={{ marginBottom: "10px" }}>
              <Label
                label={props.t("AGENT_ID")}
                edit={props.edit}
                stage={props.stage}
                t={props.t}
              />
            </div>
            <Input
              inputClass={classes.notesInput}
              name={"agentId"}
              variant={"outlined"}
              size={"small"}
              placeholder={props.t("AGENT_ID")}
              //label={<Label label={props.t('AGENT_ID')+' *'} edit={props.edit} stage={props.stage}/>}
              value={props.notes.agentId}
              inputProps={{ disabled: true }}
            />
          </Grid>
          {/* <Grid item xs={12}>
                        <div className={classes.noteLabel}>
                            <h4>{props.t('CUSTOMER_ORDER_NUMBER')}</h4>
                        </div>
                    </Grid> */}
          <Grid
            item
            size={{
              xs: 6,
            }}
          >
            <div className={classes.noteLabel} style={{ marginBottom: "10px" }}>
              <h4>{props.t("CUSTOMER_ORDER_NUMBER")}</h4>
              {props.stage === 2 ? (
                <button
                  onClick={() => {
                    props.edit(1);
                  }}
                  className={classes.button}
                  style={{
                    marginTop: "1px",
                    position: "relative",
                    top: "-3px",
                  }}
                >
                  {props.t("EDIT")}
                </button>
              ) : null}
            </div>
            <Input
              inputClass={classes.notesInput}
              name={"agentId"}
              variant={"outlined"}
              size={"small"}
              placeholder={props.t("CUSTOMER_ORDER_NUMBER")}
              //label={<Label label={props.t('CUSTOMER_ORDER_NUMBER')+' *'} edit={props.edit} stage={props.stage}/>}
              value={props.notes.externalId}
              // disabled={props.orderPlaced}
              disabled={true}
              onChange={(e) =>
                props.inputAlphaNumeric(e, (value) => {
                  props.onChangeCustomerOrderNumber(e.target.value);
                })
              }
            />
          </Grid>
        </>
      )}
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        <FormControl
          variant="outlined"
          className="custom-select-input"
          size={"small"}
        >
          <InputLabel htmlFor="outlined-age-native-simple">
            {props.t("SHIPPING_METHOD")} *
          </InputLabel>
          <Select
            native
            label="SHIPPING_METHOD"
            value={props.notes.shipmentMethodTypeId}
            inputProps={{
              name: "facilityId",
              id: "outlined-age-native-simple",
              disabled: true,
            }}
          >
            {shipmentMethodTypeList.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.name}
              </option>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        <Label
          label={props.t("NOTES")}
          edit={props.edit}
          stage={props.stage}
          t={props.t}
        />
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        <Input
          size={"small"}
          name={"notes"}
          variant={"outlined"}
          placeholder={props.t("NOTES") + "......."}
          //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
          value={props.notes.notes}
          //inputProps={{ rows: "5", cols: "10", disabled: true }}
          inputProps={{ multiline: true, rows: 5, cols: 10, disabled: true }}
        />
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        {/* <Textarea
                    name={'notes'}
                    placeholder={'Notes.......'}
                    label={<Label label="Pricing Notes" edit={props.edit} stage={props.stage}/>}
                    value={props.notes.priceNotes}
                    inputProps={{ rows: "5", cols: "10", disabled: true }}
                /> */}
      </Grid>
    </Grid>
  );
};

const Label = (props) => {
  return (
    <div className={classes.noteLabel}>
      <h4>{props.label}</h4>
      {props.stage === 2 ? (
        <button
          onClick={() => {
            props.edit(1);
          }}
          className={classes.button}
          style={{ marginTop: "1px", position: "relative", top: "-3px" }}
        >
          {props.t("EDIT")}
        </button>
      ) : null}
    </div>
  );
};

export default withTranslation("translations")(NotesBlock);
